import {AuthService} from "./AuthService";

// Admin-only bulk-email API client. Delegates to the shared AuthService axios
// layer (auth header injected per-request); never imports axios directly.
// Mirrors CampaignQualityService / UserService conventions. Response envelope
// is res.data.data.
export class EmailCampaignService {

    url = `admin/email_campaign/`;
    listUrl = `admin/email_recipient_list/`;

    // Multipart upload of a single attachment; returns {file_id, name, type}.
    uploadAttachment(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {headers: {'Content-Type': 'multipart/form-data'}};
        return AuthService.apiPost(this.url + "upload_attachment/", formData, config)
            .then(res => res.data.data);
    }

    // Immediate single send to a test address.
    sendTest(payload) {
        return AuthService.apiPost(this.url + "send_test/", payload)
            .then(res => res.data.data);
    }

    // Queue a campaign. Returns {campaign, invalid}.
    send(payload) {
        return AuthService.apiPost(this.url, payload).then(res => res.data.data);
    }

    // Paginated history. Returns {items, total, page, page_size}.
    list(params = {}) {
        return AuthService.apiGet(this.url, {params}).then(res => res.data.data);
    }

    // Single campaign detail (with per-recipient statuses).
    get(id) {
        return AuthService.apiGet(this.url + id + "/").then(res => res.data.data);
    }

    // Paginated suppression list. Returns {items, total, page, page_size}.
    listSuppressions(params = {}) {
        return AuthService.apiGet(this.url + "suppression/", {params})
            .then(res => res.data.data);
    }

    // Remove a single email from the suppression list. Returns {removed}.
    removeSuppression(email) {
        return AuthService.apiPost(this.url + "remove_suppression/", {email})
            .then(res => res.data.data);
    }

    // Delete ALL suppression records. Returns {removed}.
    clearSuppressions() {
        return AuthService.apiPost(this.url + "clear_suppression/", {})
            .then(res => res.data.data);
    }

    // Resolve the audience for a criteria object. Returns {users, count, truncated}.
    resolveRecipients(criteria) {
        return AuthService.apiPost(this.url + "resolve_recipients/", {criteria})
            .then(res => res.data.data);
    }

    // Save a named recipient list. Returns {id, name, count, ...}.
    saveRecipientList(name, emails, criteria) {
        return AuthService.apiPost(this.listUrl, {name, emails, criteria}).then(res => res.data.data);
    }

    // Paginated saved-list summaries. Returns {items, total, page, page_size}.
    listRecipientLists() {
        return AuthService.apiGet(this.listUrl).then(res => res.data.data);
    }

    // Single saved-list detail, including its emails.
    getRecipientList(id) {
        return AuthService.apiGet(this.listUrl + id + "/").then(res => res.data.data);
    }

    // Delete a saved recipient list. Returns {removed}.
    deleteRecipientList(id) {
        return AuthService.apiDelete(this.listUrl + id + "/").then(res => res.data.data);
    }
}
